<template>
	<div class="inner" v-if="loading">
		<Loader></Loader>
	</div>
	<div v-else>

		<div class="signing-content review confirm-box" v-if="allowApproval">
	        <div v-if="!declineStarted">
				<div v-if="requireInformation" class="order-view">
					<h2>{{ $t('digital.approvecontract.enter-information') }}</h2>
					<Landlord-info
                        :using-behalf-of-landlord="true"
                        :show-update-button="true"
                        :show-bank-form-fields="true"
                        :show-landlord-type="false"
                        :show-private-fields="true"
                        :show-cvr="draftContract.definition.landlord_type === 'commercial'"
                        :default-email="getAccountEmail"
                        :draft-contract="draftContract"
                        @save="requireInformation = false"
                    />
				</div>
				<div v-else>
					<div class="signing-top">
						<div class="top">
							<div class="logo">

							</div>
							<div class="content">
								<h1>{{$t('review-sign.contract.headline') }}</h1>
								<p>{{ address }}</p>
							</div>
							<div class="button-container">
								<button class="transparent" v-on:click="startDecline">{{$t('digital.approvecontract.decline')}}</button>
								<button class="purple" v-on:click="approve" :disabled="sendingApproval">
									<span v-if="!sendingApproval">{{$t('digital.approvecontract.approve')}}</span>
									<span v-if="sendingApproval">{{$t('digital.approvecontract.loading')}}</span>
								</button>
						</div>
						</div>
					</div>
					<div class="pdf-viewer">
                        <pdf-viewer :url="pdfUrl"></pdf-viewer>
					</div>
				</div>
			</div>
			<div class="decline-content inputs" v-if="declineStarted">
				<h2>{{$t('digital.approvecontract.decline-headline')}}</h2>
				<p>{{$t('digital.approvecontract.why-decline')}}</p>
				<textarea cols="60" rows="5" v-model="declineMessage"></textarea>
				<div class="button-container">
					<button class="" v-on:click="cancelDecline">{{$t('cancel')}}</button>
					<button class="purple" :disabled="savingDecline" v-on:click="submitDecline">
						{{$t('digital.approvecontract.confirm-decline')}}
						<template v-if="savingDecline">...</template>
					</button>
				</div>
			</div>
		</div>
		<div class="inner confirm-box" v-else>
			<p>{{ $t('digital-contract.approval.cannot-approve-now') }}</p>
			<router-link to="/contracts"><button class="button purple">{{ $t('digital-contract.approval.return-to-overview') }}</button></router-link>
		</div>
	</div>
</template>

<script>
	import {mapGetters} from 'vuex'

    import Loader from '../../components/Loader.vue';
    import LandlordInfo from './parts/LandlordInfo';
    import PdfViewer from "../../components/PdfViewer";

	export default {
		data: () => ({
			savingDecline: false,
			declineMessage: '',
			declineStarted: false,
            draftContract: {},
			bankRegNo: '',
			bankAccountNo: '',
			bankName: '',
			sendingApproval: false,
			loading: true,
			allowApproval: false,
			requireInformation: false,
			bankInfo: {},
			property: {}
		}),
		computed: {
			...mapGetters([
				'getToken',
                'getAccountEmail',
			]),
			pdfUrl() {
				return window.config.apiUrl + 'api/contract/' + this.$route.params.id + '?token=' + this.getToken;
			},
			address() {
				if (this.property.address) {
					return this.property.address;
				}
				return '';
			}
		},
        components:{
        	Loader,
        	LandlordInfo,
            PdfViewer
        },
		methods: {
			submitDecline() {
				this.savingDecline = true;
				axios({
					method: 'POST',
					url: window.config.apiUrl + 'api/draft-contract/' + this.$route.params.id + '/decline',
					cancelToken: window.AuthorizationCancelSource.token,
                    data: {
                    	message: this.declineMessage
                    }
				}).then(response => {
					this.$store.commit('setSuccessBarMessage', this.$t('digital-contract.approval.declined'));
					this.$router.push('/');
				}).finally(e => {
					this.savingDecline = false;
				});
			},
			startDecline() {
				this.declineStarted = true;
			},
			cancelDecline() {
				this.declineStarted = false;
			},
			approve() {
				var self = this;
				this.sendingApproval = true;
				axios({
					method: 'POST',
					url: window.config.apiUrl + 'api/draft-contract/' + this.$route.params.id + '/approve',
					cancelToken: window.AuthorizationCancelSource.token,
				}).then(response => {
					self.sendingApproval = false;
					self.$router.push('/');
				}).finally(e => {
					self.sendingApproval = false;
				});
			},
        	seen() {
        		axios({
	        		method: 'POST',
	        		url: window.config.apiUrl + 'api/digital-contract/' + this.$route.params.id + '/approval-seen',
					cancelToken: window.AuthorizationCancelSource.token,
	        	});
        	}
		},
		created() {
			axios({
				method: 'GET',
				url: window.config.apiUrl + 'api/draft-contract/' + this.$route.params.id + '/approval-status',
				cancelToken: window.AuthorizationCancelSource.token,
			}).then(response => {
				this.property = response.data.property;
				this.requireInformation = response.data.requireInformation;
				this.draftContract = response.data.draft_contract;

				if (response.data.role == 'landlord' && response.data.awaitingLandlord) {
					this.allowApproval = true;
				}
				this.bankInfo = response.data.bank;

				this.loading = false;
			});

			this.seen();
		}
	}
</script>

<style scoped>

</style>
